import { nsSimCard } from '@/app/i18n/namespaces';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
import ICONS from '@/common-utils/enums/icons';
import PropTypes from 'prop-types';


/**
 *
 */
function RenderSimUpdateTooltip({ data }) {

    return (
        <TooltipHelper
            trigger={<Icon icon={ICONS.SIM_CARDS_OFFER_PENDING} />}
            content={
                data ?
                    <Entity entity={'next_iccid.pending'} namespace={nsSimCard} data={{ simData: data }} />
                    :
                    <Entity entity={'next_iccid.pending_no_display_name'} namespace={nsSimCard} />
            }
        />
    );
}

RenderSimUpdateTooltip.propTypes = {
    data: PropTypes.string.isRequired
};

export default RenderSimUpdateTooltip;